import request from '../../utils/request';

//菜小秘大前端
export function getCxmData() {
  return request({ url: 'app/selectAppversionForList', params: { os: 'INTEGRATIONAPP' } });
}
//菜小秘蔬菜版
export function getPosData() {
  return request({ url: 'app/selectAppversionForList', params: { os: 'android' } });
}
